import React, { Component } from 'react';
import FadeIn from '../common/fadein'

class ContactPageComponent extends Component {
    render() {
        return (
            <div>
                <section className="content-page">
                    <FadeIn duration="slow">
                        <div className="content-content">
                            <h1 className="content-title">
                                Contact us
                            </h1>
                            <p className="content-subtitle">Email us : support@pixbyte.in</p>
                            <p className="content-subtitle">WhatsApp : +91 907 230 7234</p>
                        </div>
                    </FadeIn>
                </section>
            </div>
        )
    }
}

export default ContactPageComponent
